import React from 'react';
import CustomModal from './CustomModal';

const UnsavedChangeModal = props => {
  const { onCancel, onConfirm } = props;
  return (
    <CustomModal
      isShowing
      title="Unsaved Changes"
      description={
        <p>Do you want to leave? Changes you made may not be saved.</p>
      }
      onCancel={onCancel}
      onProceed={onConfirm}
      buttonCancelText="Stay"
      buttonProceedText="Leave"
    />
  );
};

UnsavedChangeModal.defaultProps = {
  onCancel: () => {},
  onConfirm: () => {},
};

export default UnsavedChangeModal;
